import Conf from '../../configuration'

import Vue from 'vue'
import VueAmplitude from 'vue-amplitude'

import Storage from '@/helpers/storage'

import gtmFunction from '@/assets/gtmFunction'

import Env from '@/modules/env'
import Tracking from '@/modules/tracking'

export default {

    pageViewAmplitude(vue, page, provider) {

        eventAmplitude(vue, 'screen_view', null, provider, page)

    },

    pageViewGA(vue, page) {

        eventGa(vue, 'screen_view', null, null, page)

    },

    pageViewAll(vue, page) {

        this.pageViewAmplitude(vue, page)
        this.pageViewGA(vue, page)
    },

    clickAll(vue, target, provider, value) {

        this.clickAmplitude(vue, target, provider, value)
        this.clickGA(vue, target, provider, value)
    },

    clickAmplitude(vue, target, provider, value) {

        eventAmplitude(vue, 'click', target, provider, false, value)
        
    },

    clickGA(vue, target, provider, value) {

        const obj = {
            'event_category': target,
            'amplitude_screen': vue.$store.getters.page,
            'event_label': provider,
            'value': value
        }

        eventGTM('click', obj)
    },

    infoAmplitude(vue, target, provider) {

        eventAmplitude(vue, 'info', target, provider)

    },

    infoGa(vue, target, provider) {

        const obj = {
            'event_category': target,
            'amplitude_screen': vue.$store.getters.page,
            'event_label': provider
        }

        eventGTM('info', obj)

    },

    popupAmplitude: function (vue, target, provider) {

        eventAmplitude(vue, 'popup', target, provider)

    },

    popupGa: function (vue, target, provider) {

        eventGa(vue, 'popup', target, provider)

    },

    popupAll: function (vue, target, provider) {

        this.popupAmplitude(vue, target, provider)
        this.popupGa(vue, target, provider)

    },

    stateAmplitude(vue, target) {

        eventAmplitude(vue, 'state', target)

    },

    firstProvider(vue, provider) {

        if(vue && vue.$amplitude) {
            vue.$amplitude.setUserProperties({ 'first_provider': provider })
        }

    },

    errorAmplitude: function (vue, message) {

        eventAmplitude(vue, 'error', message)

    },

    accountCreated: function (provider, hash) {

        Storage.setItem('userHash', hash)

        eventGa('account_created', {'event_label': provider})

    },

    accountCreatedAmplitude: function (vue, provider) {

        eventAmplitude(vue, 'account_created', null, provider, 'none')

    },

    accountAssociated: function () {

        eventGa('account_associated')

    },

    accountAssociatedAmplitude: function (vue) {

        eventAmplitude(vue, 'account_associated')

    },

    initTracking (vue) {

        if(!Env.isLocal()) {


            // Amplitude
            Vue.use(VueAmplitude, {
                apiKey: Conf.tracking.amplitudeKey,
                config: {
                    includeUtm: true,
                    includeReferrer: true,
                    saveParamsReferrerOncePerSession: false
                }
            })

            const properties = Tracking.getTracking()

            vue.$amplitude.getInstance().setUserProperties(properties)

            // GTM

            const scriptGtm = document.createElement('script')

            scriptGtm.innerHTML = gtmFunction
            document.head.appendChild(scriptGtm)


            // GTAG

            const scriptGtag = document.createElement('script')
            scriptGtag.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id="${Conf.tracking.gtagId}">`)
            document.body.appendChild(scriptGtag)
            window.gtag = function gtag() {

                window.dataLayer.push(arguments)
            }

            window.gtag('js', new Date())

            window.gtag('config', Conf.tracking.gtagId, {
                'send_page_view': false,
                'anonymize_ip': true,
                'optimize_id': Conf.tracking.optimizeId
            })

        }
    }

}

function eventGa(action, options = {}) {

    if (!Env.isLocal() && gtag) {

        if (Storage.getItem('debugTracking')) {
            console.debug(`gtag ${action} ${Object.values(options)}`)
        }


        // if is prod
        if (window.location.hostname.indexOf('cleanfox.io') > -1) {

            gtag('event', action, options)

        }

    }

}


function eventGTM(action, options = {}) {

    if (dataLayer) {

        const objOptions = {event: action, options}

        if (Storage.getItem('debugTracking')) {
            console.debug('dataLayer ', objOptions)
        }

        dataLayer.push(objOptions)
    }

}

function eventAmplitude(vue, event, target, provider, page, value) {

    if (vue && vue.$amplitude) {

        const obj = {}

        if(target) {
            obj.event_category = target

        }

        if(provider) {
            obj.event_label = provider
        }

        if (page !== 'none') {
            obj.amplitude_screen = page || vue.$store.getters.page
        }

        if(value) {
            obj.value = value
        }

        if (Storage.getItem('debugTracking')) {
            console.debug(`amplitude ${event} ${obj.event_category} ${obj.amplitude_screen} ${obj.event_label}`)
        }


        try {
            vue.$amplitude.getInstance().logEvent(event, obj)
        } catch (ignored) {
            // do nothing
        }

    }
}
